var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLottie',{attrs:{"path":_vm.media === 'Mobile'
      ? require('@/assets/lottie/buy-now-mobile.json')
      : require('@/assets/lottie/buy-now-desktop.json'),"loop":false}})}
var staticRenderFns = []

export { render, staticRenderFns }